import { DriverQualificationsType } from 'app/constants/driverQualificationsType'

export const getDanemarkDriverQualificationType = (type) => {
  let qualificationType = DriverQualificationsType.NotSet

  switch (type) {
    case 0:
      qualificationType = DriverQualificationsType.CarriageOfGoods
      break
    case 1:
      qualificationType = DriverQualificationsType.CabotageInPassengerTransport
      break
    case 2:
      qualificationType = DriverQualificationsType.TouristTransport
      break
  }

  return qualificationType
}

export const getBelgiumDriverQualificationType = (type) => {
  let qualificationType = DriverQualificationsType.NotSet

  switch (type) {
    case 16:
      qualificationType = DriverQualificationsType.Guard
      break
    case 17:
      qualificationType = DriverQualificationsType.DriverDuringTraining
      break
    case 18:
      qualificationType = DriverQualificationsType.VhiclesBelow7
      break
    case 19:
      qualificationType = DriverQualificationsType.JouniorCourier
      break
    case 20:
      qualificationType = DriverQualificationsType.VehiclesAbove7Below15
      break
    case 21:
      qualificationType = DriverQualificationsType.SeniorCourier
      break
    case 22:
      qualificationType = DriverQualificationsType.VehiclesAbove15
      break
    case 23:
      qualificationType = DriverQualificationsType.BelgiumFirstGroup
      break
    case 24:
      qualificationType = DriverQualificationsType.BelgiumSecondGroup
      break
    case 25:
      qualificationType = DriverQualificationsType.BelgiumThirdGroup
      break
    case 26:
      qualificationType = DriverQualificationsType.BelgiumFourthGroup
      break
  }

  return qualificationType
}

export const getCzechDriverQualificationType = (type) => {
  let qualificationType = DriverQualificationsType.NotSet

  switch (type) {
    case 0:
      qualificationType = DriverQualificationsType.RegularDriver
      break
    case 1:
      qualificationType = DriverQualificationsType.VehiclesAbove3Comma5Driver
      break
    case 2:
      qualificationType = DriverQualificationsType.BusDriver
      break
  }

  return qualificationType
}

export const getDriverQualificationType = (type) => {
  let qualificationType = DriverQualificationsType.NotSet

  switch (type) {
    case 0:
      qualificationType = DriverQualificationsType.VehiclesTo3Comma5
      break
    case 1:
      qualificationType = DriverQualificationsType.VehiclesFrom3Comma5To11
      break
    case 2:
      qualificationType = DriverQualificationsType.VehiclesFrom11To19
      break
    case 3:
      qualificationType = DriverQualificationsType.VehiclesAbove19
      break
    case 4:
      qualificationType = DriverQualificationsType.HighQualifiedTruckDriver
      break
    case 5:
      qualificationType = DriverQualificationsType.BusDriver
      break
    case 6:
      qualificationType = DriverQualificationsType.BusDriverAndConductor
      break
    case 7:
      qualificationType = DriverQualificationsType.TouristBusDriver
      break
    case 8:
      qualificationType = DriverQualificationsType.BigBusDriver
      break
    case 9:
      qualificationType = DriverQualificationsType.VehiclesTo3Comma5Standard
      break
    case 10:
      qualificationType =
        DriverQualificationsType.VehiclesAbove3Comma5Below3Axis
      break
    case 11:
      qualificationType = DriverQualificationsType.VehiclesAbove3Comma5Abov3Axis
      break
    case 12:
      qualificationType = DriverQualificationsType.VehiclesBelow8Group3
      break
    case 13:
      qualificationType = DriverQualificationsType.VehiclesAbove8Group3Super
      break
    case 14:
      qualificationType = DriverQualificationsType.UnqualifiedDriver
      break
    case 15:
      qualificationType = DriverQualificationsType.QualifiedDriver
      break
    case 16:
      qualificationType = DriverQualificationsType.Guard
      break
    case 17:
      qualificationType = DriverQualificationsType.DriverDuringTraining
      break
    case 18:
      qualificationType = DriverQualificationsType.VhiclesBelow7
      break
    case 19:
      qualificationType = DriverQualificationsType.JouniorCourier
      break
    case 20:
      qualificationType = DriverQualificationsType.VehiclesAbove7Below15
      break
    case 21:
      qualificationType = DriverQualificationsType.SeniorCourier
      break
    case 22:
      qualificationType = DriverQualificationsType.VehiclesAbove15
      break
    case 23:
      qualificationType = DriverQualificationsType.VehicleCombination
      break
    case 24:
      qualificationType = DriverQualificationsType.DangerousGoods
      break
    case 25:
      qualificationType =
        DriverQualificationsType.EmployeesWithSpecialistQualifications
      break
    case 26:
      qualificationType =
        DriverQualificationsType.ProfessionalDriverVehiclesAbove3Comma5Below3Axis
      break
    case 27:
      qualificationType =
        DriverQualificationsType.ProfessionalDriverVehiclesAbove3Comma5Abov3Axis
      break
    case 28:
      qualificationType =
        DriverQualificationsType.ProfessionalDriverVehicleCombination
      break
    case 29:
      qualificationType = DriverQualificationsType.TankDriver
      break
    case 30:
      qualificationType = DriverQualificationsType.TransportOfPeopleDriver
      break
    case 31:
      qualificationType =
        DriverQualificationsType.TransportOfPeopleProfessionalDriver
      break
    case 32:
      qualificationType =
        DriverQualificationsType.TransportOfPeopleQualifiedWorker
      break
    case 33:
      qualificationType =
        DriverQualificationsType.TransportOfPeopleSemiSkilledWorker
      break
    case 34:
      qualificationType = DriverQualificationsType.TransportOfPeopleForeman
      break
    case 35:
      qualificationType = DriverQualificationsType.TransportOfPeopleGarageWorker
      break
    case 36:
      qualificationType = DriverQualificationsType.FinlandBusDriver
      break
    case 37:
      qualificationType = DriverQualificationsType.TrackDriverWithTrailer
      break
    case 38:
      qualificationType = DriverQualificationsType.TractorDriver
      break
    case 39:
      qualificationType = DriverQualificationsType.RegularDriver
      break
    case 40:
      qualificationType = DriverQualificationsType.CcnlC3
      break
    case 41:
      qualificationType = DriverQualificationsType.CcnlB3
      break
    case 42:
      qualificationType = DriverQualificationsType.CcnlA3
      break
    case 43:
      qualificationType = DriverQualificationsType.CcnlF2
      break
    case 44:
      qualificationType = DriverQualificationsType.CcnlE2
      break
    case 45:
      qualificationType = DriverQualificationsType.CcnlD2
      break
    case 46:
      qualificationType = DriverQualificationsType.CcnlH1
      break
    case 47:
      qualificationType = DriverQualificationsType.CcnlG1
      break
    case 48:
      qualificationType = DriverQualificationsType.CcnlI110
      break
    case 49:
      qualificationType = DriverQualificationsType.CcnlI116
      break
    case 50:
      qualificationType = DriverQualificationsType.CcnlL110
      break
    case 51:
      qualificationType = DriverQualificationsType.CcnlL116
      break
    case 52:
      qualificationType = DriverQualificationsType.CcnlL119
      break
  }

  return qualificationType
}
